/** Versioned public contract shared by experiment, Idea Lab, and portfolio timing reports. */
export const ENTRY_TIMING_PROFILE_SCHEMA_VERSION = 1;
export const ENTRY_TIMING_STANDARD_INTRADAY_BUCKET_MINUTES = 30;
/** Canonical display and serialization order. Report producers may omit weekdays with no observations. */
export const ENTRY_TIMING_WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
//# sourceMappingURL=EntryTimingProfileTypes.js.map